<template>
  <div class="mb-3">
    <ProductsCategory v-model="form.category" :error="form.errors.category" label="Product Category"  />
    <text-input v-model="form.name" :error="form.errors.name" label="Product Name" />
  </div>
</template>

<script>
import TextInput from '@/Shared/TextInput'
import ProductsCategory from '@/components/Form/ProductsCategory'

export default {
  name: 'ProductForm',
  components: {
    TextInput,
    ProductsCategory
  },
  props: {
    form: Object
  }
}
</script>

<style>

</style>
